import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OwaSuiteHeader"*/ './lazyIndex'),
    { name: 'OwaSuiteHeader' }
);

export const lazyUpdateEmbedChatOptions: LazyAction<
    typeof lazyIndex.updateEmbedChatLastUsedDate,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateEmbedChatLastUsedDate);

export const lazyShouldLoadEmbedPreAuthOnIdle: LazyAction<
    typeof lazyIndex.shouldLoadEmbedPreAuthOnIdle,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.shouldLoadEmbedPreAuthOnIdle);

export const lazyGetChatUnreadMessageCount: LazyAction<
    typeof lazyIndex.getChatUnreadMessageCount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getChatUnreadMessageCount);
